import CurrencyConversions from '@interfaces/currency-conversions';
import { getCall } from '@services/rest-service';

// Retrieves currency currency conversions from cosmos
export const get = (): Promise<CurrencyConversions> => {
  return getCall<CurrencyConversions>('currency-conversions');
};
